export const VERSION = '2.19.0';
